"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldIconCoreInputs = exports.EmeraldIconType = void 0;
var EmeraldIconType;
(function (EmeraldIconType) {
    EmeraldIconType["Filled"] = "filled";
    EmeraldIconType["Outlined"] = "outlined";
    EmeraldIconType["Rounded"] = "rounded";
})(EmeraldIconType || (exports.EmeraldIconType = EmeraldIconType = {}));
class EmeraldIconCoreInputs {
    constructor() {
        this.type = EmeraldIconType.Filled;
        this.variant = 'icon';
        this.ariaHidden = false;
    }
}
exports.EmeraldIconCoreInputs = EmeraldIconCoreInputs;
//# sourceMappingURL=icon.inputs.js.map